// ObjectComponent constants - shared across frontend and API

import type {
  ObjectComponentType,
  ObjectComponentCategory,
  ObjectComponentCompensation,
  ObjectComponentMarketplaceVisibility,
  ObjectComponentStatus,
} from '../types/object-components';

export const OBJECT_COMPONENT_TYPE_OPTIONS: {
  value: ObjectComponentType;
  label: string;
}[] = [{ value: 'requirement', label: 'Requirement' }];

export const OBJECT_COMPONENT_CATEGORY_OPTIONS: {
  value: ObjectComponentCategory;
  label: string;
}[] = [
  { value: 'venue', label: 'Venue' },
  { value: 'catering-food', label: 'Catering - Food' },
  { value: 'catering-beverage', label: 'Catering - Beverage' },
  { value: 'product-food', label: 'Product - Food' },
  { value: 'product-beverage', label: 'Product - Beverage' },
  { value: 'product-other', label: 'Product - Other' },
];

export const OBJECT_COMPONENT_COMPENSATION_OPTIONS: {
  value: ObjectComponentCompensation;
  label: string;
}[] = [
  { value: 'paid', label: 'Paid' },
  { value: 'sponsored', label: 'Sponsored' },
  { value: 'flexible', label: 'Flexible' },
];

export const OBJECT_COMPONENT_MARKETPLACE_VISIBILITY_OPTIONS: {
  value: ObjectComponentMarketplaceVisibility;
  label: string;
}[] = [
  { value: 'private', label: 'Private' },
  { value: 'public', label: 'Public' },
  { value: 'approved-partners', label: 'Approved Partners' },
];

export const OBJECT_COMPONENT_STATUS_OPTIONS: {
  value: ObjectComponentStatus;
  label: string;
}[] = [
  { value: 'draft', label: 'Draft' },
  { value: 'open', label: 'Open' },
  { value: 'in-progress', label: 'In Progress' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
];
